export const MEMBERSHIP_LIST_COLUMN_VISIBILITY_KEY =
  "girinestham.volunteerMembershipsList.columnVisibility";

export const MEMBERSHIP_LIST_PAGE_SIZE = 50;

export const MEMBERSHIP_LIST_COLUMN_DEFS = [
  { id: "application_code", label: "Application code", defaultVisible: true, sortable: true },
  { id: "student_code", label: "Student code", defaultVisible: true, sortable: true },
  { id: "student_name", label: "Student name", defaultVisible: true, sortable: true },
  { id: "student_phone", label: "Phone", defaultVisible: false, sortable: true },
  { id: "student_email", label: "Email", defaultVisible: false, sortable: true },
  { id: "membership_name", label: "Membership", defaultVisible: true, sortable: true },
  { id: "start_date", label: "Start date", defaultVisible: true, sortable: true },
  { id: "end_date", label: "End date", defaultVisible: true, sortable: true },
  { id: "status_name", label: "Status", defaultVisible: true, sortable: true },
  { id: "application_verified", label: "Application verified", defaultVisible: true, sortable: true },
  { id: "amount", label: "Amount", defaultVisible: true, sortable: true },
  { id: "receipt_no", label: "Receipt no.", defaultVisible: false, sortable: true },
  { id: "transaction_id", label: "Transaction ID", defaultVisible: false, sortable: true },
  { id: "payment_mode_name", label: "Payment mode", defaultVisible: false, sortable: true },
  { id: "payment_sub_type_name", label: "Payment sub-type", defaultVisible: false, sortable: true },
  { id: "payment_verified", label: "Payment verified", defaultVisible: false, sortable: true },
  { id: "payment_date", label: "Payment date", defaultVisible: false, sortable: true },
  { id: "submitted_at", label: "Submitted at", defaultVisible: true, sortable: true },
  { id: "approved_by_name", label: "Approved by", defaultVisible: false, sortable: true },
  { id: "approved_at", label: "Approved at", defaultVisible: false, sortable: true },
  { id: "remarks", label: "Remarks", defaultVisible: false, sortable: false },
];
